import _ from 'underscore';
import $ from 'jquery';

/**
 * Get the position that relative to table row
 *
 * @param {String} str the css function string
 * @param {int} defaultValue default value
 * @returns {int} the parsed result
 */
function parseNumber(str, defaultValue = 0) {
  const value = parseFloat(str);

  return _.isFinite(value) ? value : defaultValue;
}

/**
 * Get the position that relative to table row
 *
 * @param {int} offsetTop pixels that offset the popover view and the row top, default as -10
 * @param {int} offsetLeft pixels that offset the popover view and the row left, default as 5
 * @returns {Object} the exact distance between popover view and the row
 */
export function relativeToTableRow({
  offsetTop = -10,
  offsetLeft = 5,
} = {}) {
  return function relativeToTableRowFun(view) {
    const $target = $(view.target);
    const $tr = $target.closest('tr');

    if ($tr.length === 0) {
      throw new Error('Cannot find the table row');
    }

    const $body = $(document.body);

    const height = view.el.clientHeight;
    const paddingBottom = parseNumber($body.css('padding-bottom'));
    const topMax = $body.innerHeight() - height - paddingBottom;
    const top = Math.min($tr.offset().top + offsetTop, topMax);

    const width = view.el.clientWidth;
    const paddingRight = parseNumber($body.css('padding-right'));
    const leftMax = $body.innerWidth() - width - paddingRight;
    const left = Math.min($target.offset().left + $target.width() + offsetLeft, leftMax);

    return { isAbsolute: true, top, left };
  };
}
